import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    input,
    OnInit,
    Signal,
    signal, viewChild
} from '@angular/core';
import {timer} from 'rxjs';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatError, MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {FieldTree, FormField} from "@angular/forms/signals";
import {FieldErrorsComponent} from "../field-errors/field-errors.component";

@Component({
    selector: 'aa-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatHint, MatError, FieldErrorsComponent, FormField]
})
export class PasswordInputComponent implements OnInit {

    inputElem = viewChild<ElementRef>('input');

    formField = input.required<FieldTree<string,any>>();
    label = input('');
    placeholder = input('');
    required = input(false);
    autofocus = input(false);
    hint = input<string>();

    visible = signal(false);

    constructor() {
    }

    ngOnInit(): void {
    }

    focus() {
        timer(100).subscribe(() => {
            this.inputElem()?.nativeElement.focus()
        });
    }

    toggleVisibility() {
        this.visible.set(!this.visible());
    }

    getType: Signal<string> = computed(() => this.visible()? 'text' : 'password');

    getIcon: Signal<string> = computed(() => this.visible()? 'visibility_off' : 'visibility');

    getTooltip: Signal<string> = computed(() => this.visible()? 'Hide password' : 'Show password');
}
